import { useState, useEffect } from 'react';

export default function useDeviceType() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [temp, setTemp] = useState(() =>
    typeof window !== 'undefined' && window.innerWidth <= 1536 ? 400 : 500
  );
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      setTemp(window.innerWidth <= 1536 ? 400 : 500);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    mobil: isMobile,
    laptop: !isMobile,
    temp: temp,
  };
}
